export const SET_RESTAURANT_LIST = "set-restaurant-list";
